export default __webpack_public_path__ + "static/media/mindwell_sig.c1d17a03.png";